import * as ImportTypes from 'documents-ui/constants/ImportTypes';
import AllowedDocumentTypes from 'documents-ui/lib/AllowedDocumentTypes';
// @ts-expect-error File is untyped
import addScript from 'documents-ui/lib/addScript';
import ButtonWithEditWarning from './ButtonWithEditWarning';
import { useEffect, useState } from 'react';
import { DropboxIcon } from 'foundations-assets/icons/components/DropboxIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const isLoaded = () => {
  // @ts-expect-error Dropbox is not defined
  return window.Dropbox === undefined;
};
const DropboxButton = ({
  useMultiSelect,
  importFile,
  editWarningConfig,
  onClick
}) => {
  const [loaded, setLoaded] = useState(isLoaded());
  useEffect(() => {
    addScript('https://www.dropbox.com/static/api/2/dropins.js', {
      id: 'dropboxjs',
      'data-app-key': 'm0b0umqmsxapje4'
    }).then(() => {
      setLoaded(isLoaded());
    }).catch(error => {
      console.error(error);
    });
  });
  const handleSuccess = files => {
    files.forEach(file => importFile({
      file,
      type: ImportTypes.DROPBOX
    }));
  };
  const handleClick = () => {
    // @ts-expect-error Dropbox is not defined
    window.Dropbox.choose({
      success: handleSuccess,
      multiselect: useMultiSelect,
      extensions: AllowedDocumentTypes,
      linkType: 'direct'
    });
    onClick();
  };
  return /*#__PURE__*/_jsx(ButtonWithEditWarning, Object.assign({}, editWarningConfig, {
    onClick: handleClick,
    disabled: loaded,
    icon: DropboxIcon,
    children: "Dropbox"
  }));
};
export default DropboxButton;